import React from "react";
import { useTranslate } from "@refinedev/core";
import { UserOutlined, TeamOutlined } from "@ant-design/icons";
import { TabHub } from "../../components/TabHub";
import { UserList } from "../users/list";
import { UserGroupList } from "../user-groups/list";

/**
 * Équipe hub — who can act, and as what.
 *
 * Like the catalogue, this is operational rather than configuration: adding a
 * tuner is a weekly task, so it lives at top level instead of inside settings.
 */
export const TeamPage: React.FC = () => {
  const _t = useTranslate();

  return (
    <div className="max-w-7xl mx-auto">
      <TabHub
        title={_t("team.team", "Team")}
        subtitle={_t("team.subtitle", "")}
        items={[
          {
            key: "users",
            label: _t("team.tabs.users", "Users"),
            icon: <UserOutlined />,
            children: <UserList hideHeader />,
          },
          {
            key: "groups",
            label: _t("team.tabs.groups", "Groups"),
            icon: <TeamOutlined />,
            children: <UserGroupList hideHeader />,
          },
        ]}
      />
    </div>
  );
};
